import { render, staticRenderFns } from "./VuesticPageNotFoundCustom.vue?vue&type=template&id=3f560265"
import script from "./VuesticPageNotFoundCustom.vue?vue&type=script&lang=js"
export * from "./VuesticPageNotFoundCustom.vue?vue&type=script&lang=js"
import style0 from "./VuesticPageNotFoundCustom.vue?vue&type=style&index=0&id=3f560265&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f560265')) {
      api.createRecord('3f560265', component.options)
    } else {
      api.reload('3f560265', component.options)
    }
    module.hot.accept("./VuesticPageNotFoundCustom.vue?vue&type=template&id=3f560265", function () {
      api.rerender('3f560265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/404-pages/VuesticPageNotFoundCustom.vue"
export default component.exports